<template>
  <div
    class="position-relative"
    :class="type === 'light' ? 'light-inputField' : 'grey-inputField'"
  >
    <img
      class="search-icon"
      src="@/assets/newimg/market-place/search-icon.svg"
      alt="search-icon"
    />
    <b-form-input
      class="search-input"
      :placeholder="placeholder"
      type="search"
      debounce="500"
      v-model="vmodel[modelKey]"
      @update="performSearch"
      @focus="sendFocusEvent"
    />
  </div>
</template>

<script>
export default {
  name: "SearchBar",
  data() {
    return {
      searchQuery: "",
    };
  },
  props: {
    vmodel: {
      type: Object,
      required: true,
    },
    modelKey: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: "grey",
    },
    placeholder: {
      type: String,
      default: "Search",
    },
  },
  methods: {
    performSearch() {
      this.$emit("search-data", this.searchQuery);
    },
    sendFocusEvent() {
      this.$emit("focus", this.searchQuery);
    },
  },
};
</script>

<style scoped>
.grey-inputField,
.light-inputField .search-icon {
  position: absolute;
  top: 10px;
  left: 10px;
}

.grey-inputField .search-input {
  box-sizing: border-box;
  background: rgba(114, 115, 142, 0.08);
  border-radius: 12px;
  font-family: "Montserrat", sans-serif;
  font-weight: var(--weight-R);
  font-size: var(--size-14);
  color: #333333;
  padding: 5px 10px 5px 35px;
  border-color: transparent;
}

.grey-inputField,
.light-inputField .search-input::placeholder {
  color: #72738e80;
  font-family: "Montserrat", sans-serif;
  font-weight: var(--weight-R);
  font-size: 16px;
}
.grey-inputField,
.light-inputField .search-input:focus {
  box-shadow: unset !important;
}

.light-inputField .search-input {
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 12px;
  font-family: "Montserrat", sans-serif;
  font-weight: var(--weight-R);
  font-size: var(--size-14);
  color: #333333;
  padding: 5px 10px 5px 35px;
  border: 1px solid #c4c4c4;
}

.light-inputField .search-input::placeholder {
  color: #72738e80;
  font-family: "Montserrat", sans-serif;
  font-weight: var(--weight-R);
  font-size: var(--size-14);
}
.grey-inputField .search-input,
.light-inputField .search-input {
  box-sizing: border-box;
  border-radius: 12px;
  font-family: "Montserrat", sans-serif;
  font-weight: var(--weight-R);
  font-size: 16px; /* 👈 prevent iOS zoom */
  color: #333333;
  padding: 5px 10px 5px 35px;
  border-color: transparent;
  border: 0.5px solid #c4c4c4;
}
</style>
